import ActionLogoSvg from '@/assets/action-logo.svg';

export const convertSvgToPng = async (svgElement, width = 200, height = 80) => {
    return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        canvas.width = width * 2;
        canvas.height = height * 2;
        const ctx = canvas.getContext('2d');
        ctx.scale(2, 2);
        
        const img = new Image();
        img.onload = () => {
            ctx.drawImage(img, 0, 0, width, height);
            resolve(canvas.toDataURL('image/png'));
        };
        img.src = svgElement;
    });
};

export const getActionLogoPng = async (width = 200, height = 80) => {
    return await convertSvgToPng(ActionLogoSvg, width, height);
}; 